
const TextareaField = ({
    id,
    name,
    className,
    selectedValue,
    onChange,
    maxLength,
    readOnly,
    disabled,
    placeholder,
    checked
}: any
) => {
    return (
        <textarea
            id={id ? id : name}
            name={name}
            className={className}
            value={selectedValue}
            onChange={onChange}
            maxLength={maxLength}
            readOnly={readOnly}
            disabled={disabled}
            placeholder={placeholder}
        />
    )
};
export default TextareaField;